(() => {
  // app/scripts/announcement-bar-component.js
  var customElementsName = "scrolling-content";
  !window.customElements.get(customElementsName) && window.customElements.define(customElementsName, class extends HTMLElement {
    constructor() {
      super();
      this.resizeObserver = null;
      this.resizeCleanup = null;
      this.boundHandleSectionLoad = null;
      this.boundHandleSectionUnload = null;
      this.animationFrameId = null;
      this.scrollSpeed = 1;
      this.autoplayTimer = null;
      this.currentIndex = 0;
      this.isAnimating = false;
      this.autoplayRunning = false;
    }
    connectedCallback() {
      requestAnimationFrame(() => {
        this.calculateHeight();
        setTimeout(() => this.calculateHeight(), 100);
      });
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => this.init(), { once: true });
      } else {
        requestAnimationFrame(() => this.init());
      }
      const sectionRoot = this.closest('[id^="shopify-section-"]');
      if (sectionRoot) {
        this.sectionId = sectionRoot.id;
        this.boundHandleSectionLoad = this.handleSectionLoad.bind(this);
        this.boundHandleSectionUnload = this.handleSectionUnload.bind(this);
        document.addEventListener("shopify:section:load", this.boundHandleSectionLoad);
        document.addEventListener("shopify:section:unload", this.boundHandleSectionUnload);
      }
    }
    calculateHeight() {
      const track = this.querySelector(".marquee__track");
      if (!track) {
        return;
      }
      const items = Array.from(track.querySelectorAll(".block-item"));
      if (!items.length) {
        return;
      }
      let maxHeight = 0;
      items.forEach((item) => {
        const rect = item.getBoundingClientRect();
        maxHeight = Math.max(maxHeight, rect.height);
      });
      this.style.setProperty("--marquee-item-height", `${Math.ceil(maxHeight)}px`);
      this.classList.add("initialized");
    }
    disconnectedCallback() {
      this.cleanup();
      if (this.sectionId && this.boundHandleSectionLoad && this.boundHandleSectionUnload) {
        document.removeEventListener("shopify:section:load", this.boundHandleSectionLoad);
        document.removeEventListener("shopify:section:unload", this.boundHandleSectionUnload);
        this.boundHandleSectionLoad = null;
        this.boundHandleSectionUnload = null;
      }
    }
    handleSectionLoad(event) {
      if (event?.target?.id === this.sectionId) {
        requestAnimationFrame(() => this.init());
      }
    }
    handleSectionUnload(event) {
      if (event?.target?.id === this.sectionId) {
        this.cleanup();
      }
    }
    init() {
      this.calculateHeight();
      const track = this.querySelector(".marquee__track");
      if (!track) {
        return;
      }
      const allItems = Array.from(track.querySelectorAll(".block-item"));
      allItems.forEach((item) => {
        if (item.dataset.isClone === "true") {
          item.remove();
        }
      });
      const items = Array.from(track.querySelectorAll(".block-item"));
      if (!items.length) {
        return;
      }
      this.scrollSpeed = parseFloat(this.dataset.speed) || 1;
      this.duration = parseFloat(this.dataset.duration) || 500;
      const direction = this.dataset.direction || "horizontal";
      if (direction === "horizontal") {
        this.setupMarquee(track, items, {
          axis: "X",
          dimension: "width",
          flexDirection: "row",
          isReverse: false,
          calculateSize: () => this.getBoundingClientRect().width,
          updateItemSize: (item, size) => {
            item.style.width = `${size}px`;
          },
          updateContainer: () => {
          },
          handleResize: (allItems2, size) => {
            allItems2.forEach((item) => {
              item.style.width = `${size}px`;
            });
          }
        });
      } else if (direction === "horizontal-reverse") {
        this.setupMarquee(track, items, {
          axis: "X",
          dimension: "width",
          flexDirection: "row",
          isReverse: true,
          calculateSize: () => this.getBoundingClientRect().width,
          updateItemSize: (item, size) => {
            item.style.width = `${size}px`;
          },
          updateContainer: () => {
          },
          handleResize: (allItems2, size) => {
            allItems2.forEach((item) => {
              item.style.width = `${size}px`;
            });
          }
        });
      } else if (direction === "vertical") {
        this.setupMarquee(track, items, {
          axis: "Y",
          dimension: "height",
          flexDirection: "column",
          calculateSize: () => {
            items.forEach((item) => {
              item.style.height = "";
              item.style.minHeight = "";
            });
            void track.offsetHeight;
            let itemHeight = 0;
            items.forEach((item) => {
              const rect = item.getBoundingClientRect();
              itemHeight = Math.max(itemHeight, rect.height);
            });
            if (itemHeight === 0) {
              itemHeight = 40;
            }
            return itemHeight;
          },
          updateItemSize: (item, size) => {
            item.style.height = `${size}px`;
            item.style.minHeight = `${size}px`;
          },
          updateContainer: (size) => {
            this.style.height = `${size}px`;
            this.style.overflow = "hidden";
            track.style.overflow = "hidden";
            track.style.height = "";
          },
          handleResize: (allItems2, size, originalItems) => {
            originalItems.forEach((item) => {
              item.style.height = "";
              item.style.minHeight = "";
            });
            void track.offsetHeight;
            let newItemHeight = 0;
            originalItems.forEach((item) => {
              const rect = item.getBoundingClientRect();
              newItemHeight = Math.max(newItemHeight, rect.height);
            });
            if (newItemHeight === 0) {
              newItemHeight = size;
            }
            this.style.height = `${newItemHeight}px`;
            track.style.height = "";
            allItems2.forEach((item) => {
              item.style.height = `${newItemHeight}px`;
              item.style.minHeight = `${newItemHeight}px`;
            });
            return newItemHeight;
          }
        });
      }
    }
    setupMarquee(track, items, config) {
      const originalItemsCount = items.length;
      const { axis, flexDirection, isReverse = false, calculateSize, updateItemSize, updateContainer, handleResize } = config;
      track.dataset.originalCount = originalItemsCount.toString();
      let itemSize = calculateSize();
      updateContainer(itemSize);
      if (originalItemsCount > 1) {
        items.forEach((item) => {
          updateItemSize(item, itemSize);
          item.style.flexShrink = "0";
          const clone = item.cloneNode(true);
          updateItemSize(clone, itemSize);
          clone.style.flexShrink = "0";
          clone.dataset.isClone = "true";
          track.appendChild(clone);
        });
      } else {
        items.forEach((item) => {
          updateItemSize(item, itemSize);
          item.style.flexShrink = "0";
        });
      }
      const allItems = Array.from(track.querySelectorAll(".block-item"));
      track.style.display = "flex";
      if (flexDirection !== "row") {
        track.style.flexDirection = flexDirection;
      }
      track.style.transition = "none";
      this.currentIndex = isReverse ? originalItemsCount - 1 : 0;
      const initialPosition = isReverse ? -itemSize * this.currentIndex : 0;
      track.style.transform = `translate${axis}(${initialPosition}px)`;
      const transitionDuration = this.duration;
      const autoplayTimeout = (this.scrollSpeed || 1) * 1e3;
      const slideNext = () => {
        if (this.isAnimating || !this.autoplayRunning) {
          return;
        }
        this.isAnimating = true;
        if (isReverse) {
          this.currentIndex--;
          if (originalItemsCount > 1 && this.currentIndex < 0) {
            const lastCloneIndex = originalItemsCount * 2 - 1;
            const targetPosition = -lastCloneIndex * itemSize;
            track.style.transition = `transform ${transitionDuration}ms ease-in-out`;
            track.style.transform = `translate${axis}(${targetPosition}px)`;
            setTimeout(() => {
              track.style.transition = "none";
              this.currentIndex = originalItemsCount - 1;
              track.style.transform = `translate${axis}(${-itemSize * this.currentIndex}px)`;
              void (axis === "X" ? track.offsetWidth : track.offsetHeight);
              this.isAnimating = false;
            }, transitionDuration);
          } else {
            const targetPosition = -itemSize * this.currentIndex;
            track.style.transition = `transform ${transitionDuration}ms ease-in-out`;
            track.style.transform = `translate${axis}(${targetPosition}px)`;
            setTimeout(() => {
              this.isAnimating = false;
            }, transitionDuration);
          }
        } else {
          this.currentIndex++;
          if (originalItemsCount > 1 && this.currentIndex >= originalItemsCount) {
            const targetPosition = -itemSize * this.currentIndex;
            track.style.transition = `transform ${transitionDuration}ms ease-in-out`;
            track.style.transform = `translate${axis}(${targetPosition}px)`;
            setTimeout(() => {
              track.style.transition = "none";
              this.currentIndex = 0;
              track.style.transform = `translate${axis}(0)`;
              void (axis === "X" ? track.offsetWidth : track.offsetHeight);
              this.isAnimating = false;
            }, transitionDuration);
          } else {
            const targetPosition = -itemSize * this.currentIndex;
            track.style.transition = `transform ${transitionDuration}ms ease-in-out`;
            track.style.transform = `translate${axis}(${targetPosition}px)`;
            setTimeout(() => {
              this.isAnimating = false;
            }, transitionDuration);
          }
        }
      };
      const setAutoplayTimer = () => {
        if (originalItemsCount <= 1) {
          return;
        }
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
        }
        this.autoplayTimer = setInterval(() => {
          slideNext();
        }, autoplayTimeout);
        this.autoplayRunning = true;
      };
      const stopAutoplayTimer = () => {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
        this.autoplayRunning = false;
      };
      const startAutoplay = () => {
        if (!this.autoplayRunning) {
          setAutoplayTimer();
        }
      };
      const stopAutoplay = () => {
        stopAutoplayTimer();
      };
      startAutoplay();
      this.setupHoverPause(track, originalItemsCount, startAutoplay, stopAutoplay);
      const handleResizeEvent = () => {
        stopAutoplay();
        let newSize;
        if (axis === "X") {
          newSize = this.getBoundingClientRect().width;
          handleResize(allItems, newSize);
        } else {
          const result = handleResize(allItems, itemSize, items);
          newSize = result !== void 0 ? result : itemSize;
        }
        itemSize = newSize;
        this.currentIndex = isReverse ? originalItemsCount - 1 : 0;
        track.style.transition = "none";
        const resetPosition = isReverse ? -itemSize * this.currentIndex : 0;
        track.style.transform = `translate${axis}(${resetPosition}px)`;
        this.isAnimating = false;
        setTimeout(() => {
          startAutoplay();
        }, 100);
      };
      if ("ResizeObserver" in window) {
        this.resizeObserver = new ResizeObserver(() => {
          requestAnimationFrame(handleResizeEvent);
        });
        this.resizeObserver.observe(this);
        this.resizeCleanup = () => {
          stopAutoplay();
          if (this.hoverCleanup) {
            this.hoverCleanup();
            this.hoverCleanup = null;
          }
          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
          }
        };
      } else {
        window.addEventListener("resize", handleResizeEvent);
        this.resizeCleanup = () => {
          stopAutoplay();
          if (this.hoverCleanup) {
            this.hoverCleanup();
            this.hoverCleanup = null;
          }
          window.removeEventListener("resize", handleResizeEvent);
        };
      }
    }
    // Common method to setup hover pause/resume for both horizontal and vertical
    setupHoverPause(track, itemsCount, startAutoplayFn, stopAutoplayFn) {
      if (itemsCount <= 1) {
        return;
      }
      const handleMouseEnter = () => {
        if (stopAutoplayFn) {
          stopAutoplayFn();
        }
      };
      const handleMouseLeave = () => {
        if (startAutoplayFn) {
          startAutoplayFn();
        }
      };
      track.addEventListener("mouseenter", handleMouseEnter);
      track.addEventListener("mouseleave", handleMouseLeave);
      this.hoverCleanup = () => {
        track.removeEventListener("mouseenter", handleMouseEnter);
        track.removeEventListener("mouseleave", handleMouseLeave);
      };
    }
    cleanup() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
      this.autoplayRunning = false;
      this.isAnimating = false;
      if (this.resizeCleanup) {
        this.resizeCleanup();
        this.resizeCleanup = null;
      }
    }
  });
})();
